module.exports = __webpack_public_path__ + "static/media/freestocks-9UVmlIb0wJU-unsplash.36962982.jpg";